// extracted by mini-css-extract-plugin
module.exports = {"component":"ResultBar_component__GdsuT","group":"ResultBar_group__ef0hY","stepContainer":"ResultBar_stepContainer__W1AmO","header":"ResultBar_header__mcSV2"};